/*!

=========================================================
* Purity UI Dashboard - v1.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/purity-ui-dashboard
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/purity-ui-dashboard/blob/master/LICENSE.md)

* Design by Creative Tim & Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom";
import {HashRouter, Redirect, Route, Switch} from "react-router-dom";

import AuthLayout from "layouts/Auth.js";
import AdminLayout from "layouts/Admin.js";
import SchoolLayout from "layouts/School.js";
import RTLLayout from "layouts/RTL.js";
import Logout from "./views/Auth/Logout/Logout";
import {LanguageProvider} from "./contexts/LanguageContext";
import {StaffAttendanceCheckin} from "./views/Dashboard/HRIS";

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) =>
            localStorage.getItem("userInfo") ? (
                <Component {...props} />
            ) : (
                <Redirect to="/auth/signin" />
            )
        }
    />
);

const RoleRoute = ({ ...rest }) => {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    const Component = userInfo?.roleCode === "SUPER_ADMIN" ? AdminLayout : SchoolLayout;

    return <PrivateRoute {...rest} component={Component} />;
};


    ReactDOM.render(
        <LanguageProvider>
            <HashRouter>
                <Switch>
                    {/* Public staff attendance check-in (QR scan destination) — no auth */}
                    <Route path="/staff-attendance" component={StaffAttendanceCheckin}/>
                    <Route path="/signout" component={Logout}/>
                    <Route path="/signin" component={AuthLayout}/>
                    <Route path="/auth" component={AuthLayout}/>
                    <Route path="/auth/signup" component={AuthLayout}/>
                    <RoleRoute path="/admin"/>
                    <PrivateRoute path="/rtl" component={RTLLayout}/>
                    <Redirect from="/" to="/admin/dashboard"/>
                </Switch>
            </HashRouter>
        </LanguageProvider>,
        document.getElementById("root")
    );

// Register the offline app-shell service worker so the dashboard (and the bell
// scheduler with it) can boot with no network. Combined with the IndexedDB
// sound cache, a scheduled bell still rings when the browser is opened offline.
// Registered only in production — the CRA dev server does not serve the SW.
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
    window.addEventListener("load", () => {
        const publicUrl = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
        navigator.serviceWorker
            .register(`${publicUrl}/service-worker.js`)
            .catch((err) => console.warn("Service worker registration failed:", err));
    });
}

// ReactDOM.render(
//     <HashRouter>
//         <Switch>
//             <Route path={`/auth`} component={AuthLayout} />
//             <Route path={`/admin`} component={AdminLayout} />
//             <Route path={`/rtl`} component={RTLLayout} />
//             <Redirect from={`/`} to="/admin/dashboard" />
//         </Switch>
//     </HashRouter>
//     ,
//     document.getElementById("root")
// );
